import React, {ReactElement, useState} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "shared/StyledComponents";
import {BaseApp} from "shared/BaseApp";
import {FormGenContainer} from "shared/FormGenContainer";
import {Settings} from "./types";
import {Button, useTheme} from "@mui/material";

function SettingsView(props: { settings: Settings, setSettings: (settings: Settings) => void }): ReactElement {
  const theme = useTheme();
  const [settings_, setSettings_] = useState<Settings>(props.settings.clone());
  return <StyledBoxColumn style={{height: 560, gap: 0}}>
    <FormGenContainer
      style={{zIndex: 2000, flexGrow: 1, minWidth: 0,  width: 360}} content={settings_}
      onContainerWillSave={() => setSettings_(settings_.clone())}/>
    <StyledBoxRow>
      <StyledSpan/>
      <Button onClick={() => BaseApp.CONTEXT.hideDialog()}>Cancel</Button>
      <Button
        onClick={() => {
          BaseApp.CONTEXT.hideDialog();
          props.setSettings(settings_);
        }}
        variant="contained">
        Save
      </Button>
    </StyledBoxRow>
  </StyledBoxColumn>;
}

export class SettingsHelper {

  static showDialog(settings: Settings, setSettings: (settings: Settings) => void): void {
    BaseApp.CONTEXT.showCustomDialog("Settings", <SettingsView settings={settings} setSettings={setSettings}/>);
  }
}